import { render, staticRenderFns } from "./DialogDispute.vue?vue&type=template&id=6dc3a9e1"
import script from "./DialogDispute.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogDispute.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports